import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EndPointApi } from '@helpers/endpointapi';
import { TrendGraphView } from 'ops/common/models/trend-graph-view';

@Injectable({ providedIn: 'root' })
export class TrendGraphViewsApiService {
    private domain: string;
    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    public getAll(): Observable<TrendGraphView[]> {
        return this.http.get<TrendGraphView[]>(`${this.domain}/api/trend-graph-views`);
    }

    public save(view: TrendGraphView): Observable<string> {
        return this.http.post(`${this.domain}/api/trend-graph-views`, view, {
            responseType: 'text',
        });
    }

    public update(view: TrendGraphView): Observable<string> {
        return this.http.put(`${this.domain}/api/trend-graph-views/` + view.id, view, {
            responseType: 'text',
        });
    }

    public delete(viewId: string): Observable<string> {
        return this.http.delete(`${this.domain}/api/trend-graph-views/` + viewId, {
            responseType: 'text',
        });
    }
}
